import './App.scss';
import {ProductsPage} from "./pages/ProductsPage";

export function App() {
    return (
        <ProductsPage/>
    );
}
